"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/overlay/backdrop/backdrop");
require("@/components/overlay/sheet/sheet-body");
require("@/components/overlay/sheet/sheet-footer");
require("@/components/common");
const overlay_styles_1 = require("@/components/overlay/overlay.styles");
const sheet_controller_1 = require("@/controllers/sheet-controller");
const open_state_1 = require("@/utils/open-state");
let Dialog = class Dialog extends (0, open_state_1.withOpenState)(lit_1.LitElement) {
    constructor() {
        super(...arguments);
        this.ariaModal = 'true';
        this.heading = '';
        this.description = '';
        this.sheet = new sheet_controller_1.SheetController(this, {
            // 확인이 필요한 작업에 쓰므로 의도가 불분명한 배경 클릭으로는 닫지 않는다.
            // ESC는 키보드 사용자의 탈출 수단으로 남기되, 어느 액션도 실행하지 않고 닫기만 한다.
            // 보조 액션이 파괴적인 쪽(예: 나가기)일 수 있어 취소로 간주하지 않기 때문이다.
            dismissOn: ['escape'],
        });
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'alertdialog');
    }
    render() {
        return (0, lit_1.html) `
      <mm-backdrop></mm-backdrop>
      <div class="panel" ?open=${this.open}>
        <mm-sheet-body>
          <mm-status-message
            heading=${this.heading}
            message=${this.description}
          ></mm-status-message>
          <slot></slot>
        </mm-sheet-body>
        <mm-sheet-footer
          .primaryAction=${this.primaryAction}
          .secondaryAction=${this.secondaryAction}
        ></mm-sheet-footer>
      </div>
    `;
    }
};
Dialog.styles = [
    overlay_styles_1.overlaySurfaceStyles,
    overlay_styles_1.sheetPositionStyles,
    (0, lit_1.css) `
      :host {
        --overlay-panel-min-width: var(--layout-width-narrow);
        --overlay-panel-max-width: var(--layout-width-narrow);
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-modal', reflect: true })
], Dialog.prototype, "ariaModal", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Dialog.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Dialog.prototype, "description", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], Dialog.prototype, "primaryAction", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], Dialog.prototype, "secondaryAction", void 0);
Dialog = __decorate([
    (0, decorators_js_1.customElement)('mm-dialog')
], Dialog);
exports.Dialog = Dialog;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGlhbG9nLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZGlhbG9nLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBMkQ7QUFFM0Qsa0RBQStDO0FBQy9DLGlEQUE4QztBQUM5QyxtREFBZ0Q7QUFDaEQsK0JBQTRCO0FBRzVCLHdFQUErRjtBQUMvRixxRUFBZ0U7QUFDaEUsbURBQWtEO0FBRzNDLElBQU0sTUFBTSxHQUFaLE1BQU0sTUFBTyxTQUFRLElBQUEsMEJBQWEsRUFBQyxnQkFBVSxDQUFDO0lBQTlDOztRQVcrRCxjQUFTLEdBQzNFLE1BQU0sQ0FBQTtRQUNvQixZQUFPLEdBQUcsRUFBRSxDQUFBO1FBQ1osZ0JBQVcsR0FBRyxFQUFFLENBQUE7UUFHcEMsVUFBSyxHQUFHLElBQUksa0NBQWUsQ0FBQyxJQUFJLEVBQUU7WUFDeEMsNENBQTRDO1lBQzVDLG9EQUFvRDtZQUNwRCxnREFBZ0Q7WUFDaEQsU0FBUyxFQUFFLENBQUMsUUFBUSxDQUFDO1NBQ3RCLENBQUMsQ0FBQTtJQXlCSixDQUFDO0lBdkJDLGlCQUFpQjtRQUNmLEtBQUssQ0FBQyxpQkFBaUIsRUFBRSxDQUFBO1FBQ3pCLElBQUksQ0FBQyxZQUFZLENBQUMsTUFBTSxFQUFFLGFBQWEsQ0FBQyxDQUFBO0lBQzFDLENBQUM7SUFFRCxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7aUNBRWtCLElBQUksQ0FBQyxJQUFJOzs7c0JBR3BCLElBQUksQ0FBQyxPQUFPO3NCQUNaLElBQUksQ0FBQyxXQUFXOzs7OzsyQkFLWCxJQUFJLENBQUMsYUFBYTs2QkFDaEIsSUFBSSxDQUFDLGVBQWU7OztLQUc1QyxDQUFBO0lBQ0gsQ0FBQzs7QUE3Q00sYUFBTSxHQUFHO0lBQ2QscUNBQW9CO0lBQ3BCLG9DQUFtQjtJQUNuQixJQUFBLFNBQUcsRUFBQTs7Ozs7S0FLRjtDQUNGLENBQUE7QUFDbUU7SUFBbkUsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxTQUFTLEVBQUUsWUFBWSxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsQ0FBQzt5Q0FDM0Q7QUFDb0I7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDO3VDQUFhO0FBQ1o7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzJDQUFpQjtBQUNaO0lBQS9CLElBQUEsd0JBQVEsRUFBQyxFQUFFLFNBQVMsRUFBRSxLQUFLLEVBQUUsQ0FBQzs2Q0FBNkI7QUFDNUI7SUFBL0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxDQUFDOytDQUErQjtBQWhCbkQsTUFBTTtJQURsQixJQUFBLDZCQUFhLEVBQUMsV0FBVyxDQUFDO0dBQ2QsTUFBTSxDQStDbEI7QUEvQ1ksd0JBQU0ifQ==